<template>
  <validation-observer
    v-if="
      stepData.employmentStatus
        && constants.EMPLOYMENT_STATUS_BUSINESS.includes(stepData.employmentStatus)
    "
    v-show="isRenderAfterFullfilled"
    v-slot="observer"
    slim
  >
    <form-section
      :id="questionId || 'occupation'"
      :validated="formObserver.validated && observer.failed"
      v-bind="observer"
    >
      <form-row
        :label="formRowTitle"
        :question="formRowQuestion"
        :help-text="formRowHelpText"
        :error="formObserver.validated && observer.failed"
      >
        <validation-provider
          v-slot="{ errors }"
          :vid="`${stepId}_occupation-list`"
          name="Occupation"
          :rules="rules"
        >
          <qz-autocomplete
            v-model="occupationModel"
            :data-test="fieldTrackerId"
            :placeholder="helpers.getPlaceholderResponsiveText(placeholder, isMobile)"
            :items="occupationItems"
            :errors="errors"
          />
        </validation-provider>
      </form-row>
    </form-section>
  </validation-observer>
</template>

<script>
import QuestionBase from './Base';
import { snakeCase } from 'lodash';

export default {
  name: 'question-occupation',
  extends: QuestionBase,
  data () {
    return {
      fields: ['occupationList', 'occupationKey'],
      employeeOccupations: [],
      studentOccupations: [],
    };
  },
  created () {
    this.getOccupationItems();
    this.$watch('stepData.employmentStatus', (val, prevVal) => {
      if (val !== null && prevVal !== null) {
        this.questionData.occupationList = null;
        this.questionData.occupationKey = null;
      }
    });
  },
  computed: {
    isFullTimeEducationEmploymentStatus () {
      return this.stepData.employmentStatus === this.constants.EMPLOYMENT_STATUS_FULL_TIME_EDUCATION;
    },
    formRowTitle () {
      if (this.title) return this.title;
      return this.isFullTimeEducationEmploymentStatus
        ? `What type of Student are ${this.isAdditional ? 'they' : 'you'}?`
        : `What do ${this.isAdditional ? 'they' : 'you'} do for a living?`;
    },
    formRowHelpText () {
      if (this.helpText) return this.helpText;
      return this.isFullTimeEducationEmploymentStatus
        ? `If ${this.isAdditional ? 'their' : 'your'} exact student type isn't in the list, don't worry – please select the closest match.`
        : `If ${this.isAdditional ? 'their' : 'your'} exact job isn't in the list, don't worry – please select the closest match.`;
    },
    formRowQuestion () {
      if (this.subtitle) return this.subtitle;
      return this.isFullTimeEducationEmploymentStatus ? '(e.g. School Student)' : '(e.g. Teacher or sales assistant)';
    },
    placeholder () {
      return this.isFullTimeEducationEmploymentStatus ? 'Please select a student type' : 'Please select occupation';
    },
    occupationModel: {
      get () {
        return this.questionData.occupationList;
      },
      set ({ value, text }) {
        this.questionData.occupationList = value;
        this.questionData.occupationKey = text;
      },
    },
    rules () {
      const isEmploymentStatusBusiness = this.constants.EMPLOYMENT_STATUS_BUSINESS.includes(this.stepData.employmentStatus);
      return isEmploymentStatusBusiness
        ? { occupation: { isAdditional: this.isAdditional, isFullTimeEducationEmploymentStatus: this.isFullTimeEducationEmploymentStatus } }
        : '';
    },
    occupationItems () {
      return this.isFullTimeEducationEmploymentStatus ? this.studentOccupations : this.employeeOccupations;
    },
    fieldTrackerId () {
      return snakeCase(this.questionFields.occupationList);
    },
  },
  methods: {
    async getOccupationItems () {
      [
        this.employeeOccupations,
        this.studentOccupations,
      ] = await Promise.all([
        this.getOccupationsResponse('???'),
        this.getOccupationsResponse('student'),
      ]);
    },
    async getOccupationsResponse (optionName) {
      try {
        const { data, status } = await this.$api.getOccupations(optionName);

        if (status === 'success') {
          return data.map(({ id, name }) => ({
            value: id,
            text: name,
          }));
        }
      } catch (error) {
        console.error(error);
        this.$emit('toast', {
          type: 'error',
          errors: error.toString(),
        });
      }
    },
  },
};
</script>
